// Service service using repository pattern
import { Service } from '@/shared/types';
import { serviceRepository } from '@/shared/lib/repositories/ServiceRepository';
import { realDataService } from '@/shared/services/realDataService';

export const serviceService = {
  getServices: async (): Promise<Service[]> => {
    const profile = await realDataService.getProfile();
    if (!profile) {
      throw new Error('Profile not found');
    }
    const userId = profile.userId || '';

    const result = await serviceRepository.findByUserId(userId);
    if (!result.success) {
      throw new Error(result.error || 'Failed to fetch services');
    }
    return result.data || [];
  },

  getService: async (id: string): Promise<Service | null> => {
    const result = await serviceRepository.findById(id);
    if (!result.success) {
      throw new Error(result.error || 'Failed to fetch service');
    }
    return result.data || null;
  },

  createService: async (serviceData: Partial<Service>): Promise<Service> => {
    const profile = await realDataService.getProfile();
    if (!profile) {
      throw new Error('Profile not found');
    }
    const userId = profile.userId || '';

    const { id, userId: _, ...data } = serviceData as Service;
    const result = await serviceRepository.create(userId, data);
    if (!result.success) {
      throw new Error(result.error || 'Failed to create service');
    }
    return result.data!;
  },

  updateService: async (service: Service): Promise<void> => {
    const { id, ...updates } = service;
    const result = await serviceRepository.update(id, updates);
    if (!result.success) {
      throw new Error(result.error || 'Failed to update service');
    }
  },

  deleteService: async (id: string): Promise<void> => {
    const result = await serviceRepository.delete(id);
    if (!result.success) {
      throw new Error(result.error || 'Failed to delete service');
    }
  },

  // Legacy method names
  addService: async (service: Service): Promise<void> => {
    const profile = await realDataService.getProfile();
    if (!profile) {
      throw new Error('Profile not found');
    }
    const userId = profile.userId || '';

    const { id, userId: _, ...data } = service;
    const result = await serviceRepository.create(userId, data);
    if (!result.success) {
      throw new Error(result.error || 'Failed to add service');
    }
  }
};
